import { useParams } from "react-router-dom";

export const AgentDetail = () => {
  const { agentId } = useParams<{ agentId: string }>();

  return (
    <div className="flex flex-col gap-6 p-6">
      <h1 className="text-2xl font-semibold text-foreground">Agent</h1>
      <p className="text-sm text-muted-foreground">{agentId}</p>
    </div>
  );
};
